import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from '@core/services/toastr.service';
import { Column, DPNUser, GridDataSource, GridQuery, User } from '@shared/models';
import { of } from 'rxjs';
import { catchError, filter, mapTo, switchMap } from 'rxjs/operators';
import { ModalService } from '../../modules/modal/modal.service';
import { AddUserModalComponent } from './add-user-modal/add-user-modal.component';
import { AdminUsersApiService } from './users.service';

@Component({
  selector: 'gcc-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  public dataSource: UsersDataSource;
  @ViewChild('actions', { static: true }) public actionsTemplate: TemplateRef<any>;

  constructor(
    private usersApi: AdminUsersApiService,
    private modalService: ModalService,
    private toastr: ToastrService
  ) {}

  public ngOnInit(): void {
    this.dataSource = new UsersDataSource(this.usersApi, this.actionsTemplate);
  }

  public handleAddUserModal() {
    // @ts-ignore
    this.modalService
      .openModal<{}, DPNUser>(AddUserModalComponent, { modalOptions: { class: '' } }, false)
      .pipe(
        switchMap(([user, modalRef]) => {
          return this.usersApi.add(user).pipe(
            mapTo([user, modalRef]),
            catchError(() => of(null)),
            filter(Boolean)
          );
        })
      )
      .subscribe(([User, modalRef]) => {
        // @ts-ignore
        modalRef.hide();
        this.dataSource.reload();
        this.toastr.success('users.messages.add', 2000, { user: (User as DPNUser).fullName });
      });
  }

  public handleDeleteUser(user: User): void {
    if (user.isSystem) {
      return;
    }
    this.modalService
      .confirm$({
        title: 'users.titles.delete_user',
        message: ['common.messages.delete_confirmation.description', 'common.messages.delete_confirmation.question']
      })
      .pipe(switchMap(() => this.usersApi.delete(user.userId)))
      .subscribe(() => {
        this.toastr.success('users.messages.delete', 2000, { user: user.fullName });
        this.dataSource.reload();
      });
  }
}

class UsersDataSource implements GridDataSource {
  public columns: Column.GridColumn[];
  public defaultParameters: GridQuery;

  public reload: () => void;

  constructor(private api: AdminUsersApiService, actionsTemplate: TemplateRef<any>) {
    this.columns = [
      new Column.StringColumn('fullName', 'Name').addSorting(),
      new Column.StringColumn('emailAddress', 'Email').addSorting(),
      new Column.CustomTemplateColumn('action', '', actionsTemplate).setAlignToRight()
    ];

    this.defaultParameters = new GridQuery(1, 10, 'fullName', false);
  }

  public query(params: GridQuery) {
    return this.api.getList(params);
  }
}
